<template>
    <div class="cont">
        <!-- 给展品详情页单独写一个header -->
        <div class="header">
            <!-- 展品详情页，这里是8种语言切换 -->
            <div class="language_box" v-if="islanguage_box" @click="downFlag = !downFlag">
                <img src="@/assets/img/country_1.png" class="country_img" v-if="languageId===1">
                <img src="@/assets/img/country_2.png" class="country_img" v-if="languageId===2">
                <img src="http://wfpt.smartjinsha.com/img/language/8.jpg" class="country_img" v-if="languageId===3">
                <div class="language_name">{{ languageName }}</div>
                <img :class="{ 'arrowTransform': !downFlag, 'arrowTransformReturn': downFlag}" src="@/assets/img/icon/right_icon.png" >
            </div>
            <div class="tools">
                <div class="navBtn" @click='expandMenu()'>
                    <img src="@/assets/img/menu.png" v-show="showFlag==false">
                </div>
            </div>
        </div>
        <!-- 多语种选择器 -->
        <div class="eight_language_box" v-show="downFlag === true" @click="downFlag = false">
            <div class="eight_language_list" @click.stop>
                <div class="item" v-for="i in languageList" :key="i.id" @click="changeLanguage(i)">
                    <img src="@/assets/img/country_1.png" class="country_img" v-if="i.id===1">
                    <img src="@/assets/img/country_2.png" class="country_img" v-if="i.id===2">
                    <img src="http://wfpt.smartjinsha.com/img/language/8.jpg" class="country_img" v-if="i.id===3">
                    <div :class="i.id===languageId?'active':''">{{ i.name }}</div>
                </div>
            </div>
        </div>
        <!-- 占位box -->
        <div class="replaceBox"></div>
        <!-- 下拉菜单 -->
        <div class="dropdownBox" v-show="showFlag === true" @click="closeMenu()">
            <div class="menuList" @click.stop>
                <div class="close_box" @click='closeMenu()'>
                    <img src="@/assets/img/detele.png" class="close_img">
                </div>
                <div class="item" v-for="i in menuList" :key="i.id" @click="toDetail(i)">
                    <div :class="i.id===menuIndex?'active':''">{{ i.title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'fiveheader',
    data () {
        return {
            islanguage_box: true,
            languageId: 1,
            languageName: '中文',
            languageList: [
                {
                    id: 1,
                    name: '中文'
                },
                {
                    id: 2,
                    name: 'English'
                },
                {
                    id: 3,
                    name: 'Italian'
                }
                // {
                //     id: 3,
                //     name: '日本語'
                // },
                // {
                //     id: 4,
                //     name: '한국어'
                // },
                // {
                //     id: 5,
                //     name: 'français'
                // },
                // {
                //     id: 6,
                //     name: 'Deutsche'
                // },
                // {
                //     id: 7,
                //     name: 'Español'
                // }
            ], // 语种数组
            downFlag: false,
            showFlag: false,
            menuList: [
                {
                    id: 1,
                    type: 'inside',
                    title: '首页',
                    path: '/'
                },
                {
                    id: 2,
                    type: 'inside',
                    title: '关于金沙',
                    path: '/aboutUs'
                },
                {
                    id: 3,
                    type: 'outside',
                    title: '志愿者中心',
                    path: ''
                },
                {
                    id: 4,
                    type: 'outside',
                    title: '会员中心',
                    path: ''
                },
                {
                    id: 5,
                    type: 'outside',
                    title: '团体预约',
                    path: ''
                },
                {
                    id: 6,
                    type: 'inside',
                    title: '参观指南',
                    path: '/tourGuide'
                },
                {
                    id: 7,
                    type: 'inside',
                    title: '参观导览',
                    path: '/guide'
                }
            ],
            menuIndex: 7,
            zyz_url: '', // 志愿者中心
            hyzx_url: '', // 会员中心
            ttyy_url: '' // 团体预约
        }
    },
    methods: {
        /**
         * 展开下拉菜单
         */
        expandMenu () {
            this.showFlag = !this.showFlag
        },
        /**
         * 关闭下拉菜单
         */
        closeMenu () {
            this.showFlag = false
        },
        /**
         * *选择右侧菜单
         */
        toDetail (e) {
            let vm = this
            vm.menuIndex = e.id
            if (e.path !== '') {
                if (e.path === 'tourGuide') {
                    vm.tourFlag = true
                }
                vm.$router.push(e.path)
                vm.tourFlag = false
                document.body.scrollTop = 0
                document.documentElement.scrollTop = 0
                setTimeout(() => {
                    vm.showFlag = false
                }, 300)
            } else {
                if (e.id === 3) {
                    //* 志愿者中心
                    if (vm.zyz_url === undefined || vm.zyz_url === '') {
                        vm.$toast.fail('建设中')
                    } else {
                        window.location.href = vm.zyz_url
                    }
                } else if (e.id === 4) {
                    //* 会员中心
                    if (vm.hyzx_url === undefined || vm.hyzx_url === '') {
                        vm.$toast.fail('建设中')
                    } else {
                        window.location.href = vm.hyzx_url
                    }
                } else if (e.id === 5) {
                    //* 团体预约
                    if (vm.ttyy_url === undefined || vm.ttyy_url === '') {
                        vm.$toast.fail('建设中')
                    } else {
                        window.location.href = vm.ttyy_url
                    }
                } else {
                    vm.$toast('路由错误')
                }
            }
        },
        /**
         * * 切换语种
         * *{
         * * e.id
         * * e.name
         * *}
         */
        changeLanguage (e) {
            let vm = this
            // 判断是否是5号坑主页的语种切换
            if (this.$route.meta.path !== 'fiveDetail') {
                localStorage.removeItem('current', 'fiveDetail')
            } else {
                localStorage.setItem('current', 'fiveDetail')
            }
            if (e.id === 1) {
                this.languageId = e.id
                this.languageName = e.name
                this.$router.push({path: `/${this.$route.meta.path}`})
            } else if (e.id === 2) {
                this.languageId = e.id
                this.languageName = e.name
                this.$router.push({path: `/en/${this.$route.meta.path}`})
            } else {
                this.languageId = e.id
                this.languageName = e.name
                this.$router.push({path: `/Italian/${this.$route.meta.path}`})
            }
            setTimeout(() => {
                vm.downFlag = false
            }, 300)
        },
        goBack () {
            // 首先判断当前所处页面是否是5号坑的主页面
            if (localStorage.getItem('current')) {
                this.$router.push({path: '/guide'})
                window.removeEventListener('popstate', this.goBack, false)
            } else {
                if (this.$route.path !== '/fiveDetail' || this.$route.path !== '/en/fiveDetail' || this.$route.path !== '/Italian/fiveDetail') {
                    localStorage.setItem('current', 'fiveDetail')
                    if (this.languageId === 1) {
                        this.$router.push({path: '/fiveDetail'})
                    } else if (this.languageId === 2) {
                        this.$router.push({path: '/en/fiveDetail'})
                    } else {
                        this.$router.push({path: '/Italian/fiveDetail'})
                    }
                } else {
                    localStorage.setItem('current', 'fiveDetail')
                }
            }
        }
    },
    mounted () {
        // 进入5号坑首页首先判断路由是否是英文版的路由
        if (this.$route.path.indexOf('en') !== -1) {
            this.languageId = 2
            this.languageName = 'English'
        } else if (this.$route.path.indexOf('Italian') !== -1) {
            this.languageId = 3
            this.languageName = 'Italian'
        } else {
            this.languageId = 1
            this.languageName = '中文'
        }
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL)
            window.addEventListener('popstate', this.goBack, false)
        }
    },
    created () {
        this.zyz_url = localStorage.getItem('zyz_url')
        this.hyzx_url = localStorage.getItem('hyzx_url')
        this.ttyy_url = localStorage.getItem('ttyy_url')
    },
    beforeDestroy () {
        window.removeEventListener('popstate', this.goBack, false)
    }
}
</script>
<style lang="scss" scoped>
.cont {
    color: $base-color;
    width: 100%;
    position: relative;
    z-index: 3;
    overflow: hidden;
    .eight_language_box {
        width: 100%;
        min-height: 100vh;
        background-color: rgba(0,0,0,.5);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        color: $base-color;
        padding-top: 80px;
        .eight_language_list {
            width: 238px;
            background: rgba(0,0,0,0.60);
            border: 2px solid #d9b766;
            border-radius: 10px;
            margin: 32px;
            margin-right: auto;
            .item {
                height: 88px;
                line-height: 88px;
                padding-left: 40px;
                align-items: center;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                border-bottom: 1px solid #d9b766;
                .country_img {
                    width: 36px;
                    height: 24px;
                    border-radius: 5px;
                    margin-right: 10px;
                }
            }
            .item:last-child {
                border-bottom: none;
            }
        }
    }
    .dropdownBox {
        width: 100%;
        min-height: 100vh;
        background-color: rgba(0,0,0,.5);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        color: $base-color;
        .menuList {
            width: 428px;
            background-color: #1F1108;
            // color: #ffffff;
            padding-bottom: 20px;
            margin-left: auto;
            div {
                width: 428px;
                margin: 0 auto;
                padding: 18px 0;
                text-align: center;
                font-size: 30px;
                line-height: 30px;
                letter-spacing: 1px;
                border-bottom: 1px solid rgba(205,179,120,.5);
            }
            div:last-of-type {
                border-bottom: none;
            }
            .close_box {
                height: 70px;
                position: relative;
                border-bottom: none;
                .close_img {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: 20px;
                    right: 30px;
                }
            }
            // .item {
            //     .active {
            //         color: #ffffff;
            //     }
            // }
        }
    }
    .replaceBox {
        height: 100px;
    }
    .header {
        color: $base-color;
        width: 100%;
        height: 100px;
        background: #1F1108;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .language_box {
            // padding-left: 60px;
            font-size: 44px;
            font-weight: 400;
            text-align: left;
            color: $base-color;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            // .language_name {

            // }
            img {
                width: 25px;
                height: 25px;
                margin: 20px;
            }
            .country_img {
                width: 42px;
                height: 30px;
                border-radius: 5px;
            }
            .arrowTransform{
                transition: 0.2s;
                transform-origin: center;
                transform: rotateZ(0deg);
            }
            .arrowTransformReturn{
                transition: 0.2s;
                transform-origin: center;
                transform: rotateZ(90deg);
            }
        }
        .tools {
            width: 138px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .navBtn {
                width: 32px;
                height: 32px;
                margin-left: auto;
                img {
                    width: 32px;
                    height: 32px;
                    display: block;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/guide/fiveDetail/section/fiveheader.vue